$(function() {

    $.validator.setDefaults({
        highlight: function(element) {
            $(element).closest('.form-group').addClass('has-error');
        },
        unhighlight: function(element) {
            $(element).closest('.form-group').removeClass('has-error');
        },
        errorClass: 'help-block',
        errorElement: 'span',
        errorPlacement: function(error, element) {
            if(element.parent().hasClass('input-group'))
                error.appendTo( element.parent('.input-group').parent() );
            else
                error.appendTo( element.parent() );
        }
    });

    $.validator.addMethod("alpha", function(value, element) {
        return this.optional(element) || /^[a-z]+$/i.test(value);
    }, "This field can contain Alphabets only.");

    $.validator.addMethod("alphaSpace", function(value, element) {
        return this.optional(element) || /^[a-z ]+$/i.test(value);
    }, "This field can contain Alphabets only.");

    $.validator.addMethod("mobile", function(value, element) {
        return this.optional(element) || /^[0-9]{7,15}$/.test(value);
    }, "Mobile must contain 7 to 15 digits.");

    $.validator.addMethod("mobile-no", function(value, element) {
        return this.optional(element) || /^[789][0-9]{9}$/.test(value);
    }, "Please enter valid Mobile Number.");

    $.validator.addMethod("email", function(value, element) {
        return this.optional(element) || /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$/.test(value);
    }, "Please enter a valid email address.");

    $.validator.addMethod("pincode", function(value, element) {
        return this.optional(element) || /^[0-9]{6}$/.test(value);
    }, "Please enter valid Pincode.");

    $.validator.addMethod("emailMobile", function(value, element) {
        return this.optional(element) || /^((.+@.+\..+)|([0-9]{7,15}))$/i.test(value);
    }, "Enter a valid Email or Mobile.");

    $.validator.addMethod("website", function(value, element) {
        return this.optional(element) || /^(http\:\/\/|https\:\/\/)?([a-z0-9][a-z0-9\-]*\.)+[a-z0-9][a-z0-9\-]*$/i.test(value);
    }, "Enter a valid Website Name.");

    $.validator.addMethod("ip", function(value, element) {
        return this.optional(element) || /^([0-9]{1,3}\.){3}[0-9]{1,3}$/i.test(value);
    }, "Enter a valid IP Address.");

    $.validator.addMethod("latitude", function(value, element) {
        return this.optional(element) || /^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,}$/i.test(value);
    }, "Enter a valid Latitude.");

    $.validator.addMethod("longitude", function(value, element) {
        return this.optional(element) || /^-?([1]?[1-7][1-9]|[1]?[1-8][0]|[1-9]?[0-9])\.{1}\d{1,}$/i.test(value);
    }, "Enter a valid Longitude.");

    $('#partnerLogin').validate();
    $('#partnerProfile').validate({
        rules: {
            password_verify: {
                equalTo: '#password'
            }
        },
        messages: {
            password_verify: {
                equalTo: 'Passwords do not match.'
            }
        }
    });
    $('#partnerRegister').validate({
        rules: {
            verify_password: {
                equalTo: '#password'
            }
        },
        messages: {
            verify_password: {
                equalTo: 'Passwords do not match.'
            }
        }
    });
    $('#partnerForgotPassword').validate();
    $('#customerLogin').validate();
    $('#buyFreeskyForm').validate();
    $('#customerProfile').validate({
        rules: {
            password_verify: {
                equalTo: '#password'
            }
        },
        messages: {
            password_verify: {
                equalTo: 'Passwords do not match.'
            }
        }
    });
    $('#customerAddress').validate();
    $('#webPartnerDashboard').validate();

    $('#branch-panel-password-update').validate();
    $('#branch-panel-email-update').validate();
    $('#branch-panel-mobile-update').validate();
    $('#mediaCoverageAdd').validate({
        rules: {
            link: {
                url: true,
            }
        }
    });
    $('#mediaCoverageEdit').validate({
        rules: {
            link: {
                url: true,
            }
        }
    });

    $('.validate').validate();

    $(".alpha").rules("add", {
        alpha: true,
        messages: {
            alpha: 'This field can only contain alphabets.'
        }
    });

    $(".alphaSpace").rules("add", {
        alphaSpace: true,
        messages: {
            alphaSpace: 'This field can contain alphabets and spaces.'
        }
    });

    $(".password").rules("add", {
        minlength: 6,
        messages: {
            minlength: 'Password should be atleast 6 characters long.'
        }
    });

    $(".mobile").rules("add", {
        mobile: true,
    });

    $(".mobile-no").rules("add", {
        'mobile-no': true,
    });

    $(".pincode").rules("add", {
        pincode: true,
    });

    $(".emailMobile").rules("add", {
        emailMobile: true,
    });

    $(".website").rules("add", {
        website: true,
    });

    $(".email").rules("add", {
        email: true,
        messages: {
            email: 'Please enter a valid Email.'
        }
    });

    $(".ip").rules("add", {
        ip: true,
    });

    $(".latitude").rules("add", {
        latitude: true,
    });

    $(".longitude").rules("add", {
        longitude: true,
    });

});